import { render } from "./SurveyQ4.vue?vue&type=template&id=7077cbc8&ts=true"
import script from "./SurveyQ4.vue?vue&type=script&lang=ts"
export * from "./SurveyQ4.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__